'use strict';

var SoaModel = require('bunsen/models/SoaModel');
var PortfolioModel = SoaModel.extend();
var PortfolioItemModel = require('bunsen/models/portfolio/PortfolioItemModel');
var Backbone = require('dibs-backbone');
var _ = require('underscore');
var endpoints = require('dibs-endpoints');

var relations = function () {
    return [
        {
            key: 'portfolios',
            collectionType: require('bunsen/collections/portfolio/PortfolioCollection'),
            type: Backbone.Many
        },
        {
            key: 'items',
            collectionType: require('bunsen/collections/portfolio/PortfolioItemCollection'),
            type: Backbone.Many
        },
        {
            key: 'privacySetting',
            relatedModel: SoaModel.extend(),
            type: Backbone.One
        }
    ];
};


// static properties/methods
_.extend(PortfolioModel, {
    PRIVACY_PUBLIC: 'PUBLIC',
    PRIVACY_PRIVATE: 'PRIVATE'
});

_.extend(PortfolioModel.prototype, {

    idAttribute: 'id',

    url: function () {
        return endpoints.portfolio(this.get('id') || this.get('parentId'));
    },

    defaults: {
        name: '',
        items: [],
        portfolios: [],
        itemCount: 0
    },

    relations: relations,

    removeItem: function (itemPk, itemVertical, passedOptions) {
        var portfolioItem = new PortfolioItemModel(
            {
                id : 0,
                item : {
                    id : itemPk,
                    apiType : itemVertical + 'Item'
                }
            }
        );
        portfolioItem.unset('item.seller', {silent: true}); //todo figure out how not to have to do this, null value creates error
        var options = _.extend({}, {
            url: endpoints.portfolioAddItem(this.get('id'), itemPk)
        }, passedOptions || {});
        return portfolioItem.destroy(options);
    },

    addItem: function (itemPk, itemVertical, passedOptions) {
        var portfolioItem = new PortfolioItemModel(
            {
                item : {
                    id : itemPk,
                    apiType: itemVertical + 'Item'
                }
            }
        );
        portfolioItem.unset('item.seller', {silent: true}); //todo figure out how not to have to do this, null value creates error
        var options = _.extend({}, {
            url: endpoints.portfolioAddItem(this.get('id'), itemPk)
        }, passedOptions || {});
        return portfolioItem.save({}, options);
    },

    /**
     * recursively search through 'this' portfolio and all
     * child portfolios until one with passed id is found
     */
    findChildById: function (id) {
        var models;
        var found;
        var i;

        if (this.id === id) {
            return this;
        }

        models = this.get('portfolios').models;
        for (i = 0; i < models.length; i++) {
            found = models[i].findChildById(id);
            if (found) {
                return found;
            }
        }
    },

    isP1: function () {
        return !this.get('parentId');
    },

    getDisplayName: function (p1DisplayName) {
        return this.isP1() && p1DisplayName ? p1DisplayName : this.get('name');
    },

    getNameUrl: function () {
        return this.get('name').toLowerCase().replace(/[\s\/_]+/g, '-').replace(/[^a-z0-9-]/g, '');
    },

    makePublic: function () {
        this._updatePrivacySetting(PortfolioModel.PRIVACY_PUBLIC);
    },

    makePrivate: function () {
        this._updatePrivacySetting(PortfolioModel.PRIVACY_PRIVATE);
    },

    isPublic: function () {
        return this.get('privacySetting.privacyLevel') === PortfolioModel.PRIVACY_PUBLIC;
    },

    _updatePrivacySetting: function (privacyLevel) {
        this.set('privacySetting.privacyLevel', privacyLevel);
    }

});

module.exports = PortfolioModel;



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/portfolio/PortfolioModel.js
// module id = 292
// module chunks = 64